import './i18n'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'

console.log('Mounting React app...');
ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)
